import { Stack, Tooltip, Typography } from '@mui/material';
import { AssortmentTagTooltipInfo } from '@retail/products/components';
import { SupplierItemAssortmentTag } from '@retail/products/types';
import { SubAssortmentChip } from '../SubAssortmentChip';

interface Props {
  assortmentTags: SupplierItemAssortmentTag[];
  deleteTag?: (tag: SupplierItemAssortmentTag) => void;
}

export function AssortmentTagsCell({ assortmentTags, deleteTag }: Props) {
  if (!assortmentTags.length) return <Typography variant="body2">-</Typography>;

  return (
    <Stack flexDirection="row" flexWrap="wrap" gap={0.5}>
      {assortmentTags.map((tag) => (
        <Tooltip key={tag.tagId} title={<AssortmentTagTooltipInfo assortmentTag={tag} />} arrow>
          <Stack maxWidth="100%">
            <SubAssortmentChip
              tagName={tag.tagName ?? String(tag.tagId)}
              hasEndDate={!!tag.validTo}
              onDelete={deleteTag ? () => deleteTag(tag) : undefined}
            />
          </Stack>
        </Tooltip>
      ))}
    </Stack>
  );
}
